"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _services = require("@/services");
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _utils = require("@/utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t8 in e) "default" !== _t8 && {}.hasOwnProperty.call(e, _t8) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t8)) && (i.get || i.set) ? o(f, _t8, i) : f[_t8] = e[_t8]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  traceabilityTag: [],
  listTraceabilityTagCreates: []
};
var mutations = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MutationTypes.ADD_TRACEABILITY__TAG, function (state, data) {
  state.traceabilityTag = data;
}), MutationTypes.ADD_TRACEABILITY_TAG_LIST_CREATED, function (state, data) {
  state.listTraceabilityTagCreates.push(data);
}), MutationTypes.REMOVE_TRACEABILITY_TAG_LIST_CREATED, function (state, id) {
  var newState = state.listTraceabilityTagCreates.filter(function (i) {
    return i.id !== id;
  });
  state.listTraceabilityTagCreates = newState;
}), MutationTypes.RESET_TRACEABILITY_TAG_LIST_CREATED, function (state) {
  state.listTraceabilityTagCreates = [];
});
var getters = {
  listTraceabilityTags: function listTraceabilityTags(state) {
    return state.traceabilityTag;
  },
  listTraceabilityTagsCreate: function listTraceabilityTagsCreate(state) {
    return state.listTraceabilityTagCreates;
  }
};
var actions = {
  // eslint-disable-trailing-spaces
  fetchTraceabilityTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, payload) {
      var commit, rootState, params, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit, rootState = _ref.rootState;
            _context.p = 1;
            params = {
              farm: rootState.farm.farm.id
            };
            params = Object.assign(params, payload);
            _context.n = 2;
            return _services.traceabilityTagService.fetch(params);
          case 2:
            response = _context.v;
            commit(MutationTypes.ADD_TRACEABILITY__TAG, response.data);
            return _context.a(2, response.data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  fetchTraceabilityTagId: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3, numberBatch) {
      var commit, rootState, _yield$traceabilityTa, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref3.commit, rootState = _ref3.rootState;
            _context2.p = 1;
            _context2.n = 2;
            return _services.traceabilityTagService.fetchItem(numberBatch);
          case 2:
            _yield$traceabilityTa = _context2.v;
            data = _yield$traceabilityTa.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }()),
  createTraceabilityTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5, payload) {
      var commit, rootState, payloadSend, _yield$traceabilityTa2, data, successMessage, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref5.commit, rootState = _ref5.rootState;
            _context3.p = 1;
            payloadSend = _objectSpread(_objectSpread({}, payload), {}, {
              farmId: rootState.farm.farm.id
            });
            if (payloadSend.fabricationDate) payloadSend.fabricationDate = (0, _utils.convertDateISO)(payloadSend.fabricationDate);
            if (payloadSend.expirationDate) payloadSend.expirationDate = (0, _utils.convertDateISO)(payloadSend.expirationDate);
            if (payloadSend.harvestDate) payloadSend.harvestDate = (0, _utils.convertDateISO)(payloadSend.harvestDate);
            _context3.n = 2;
            return _services.traceabilityTagService.create(payloadSend);
          case 2:
            _yield$traceabilityTa2 = _context3.v;
            data = _yield$traceabilityTa2.data;
            successMessage = _router.default.app.$t('pages.traceability_tags.messages.create_success');
            _helpers.messageHelper.success(successMessage);
            commit(MutationTypes.ADD_TRACEABILITY_TAG_LIST_CREATED, data);
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()),
  editTraceabilityTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref7, payload) {
      var commit, rootState, payloadSend, id, _yield$traceabilityTa3, data, successMessage, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref7.commit, rootState = _ref7.rootState;
            _context4.p = 1;
            payloadSend = _objectSpread(_objectSpread({}, payload), {}, {
              farmId: rootState.farm.farm.id
            });
            id = payload.id;
            if (payloadSend.fabricationDate) payloadSend.fabricationDate = (0, _utils.convertDateISO)(payloadSend.fabricationDate);
            if (payloadSend.expirationDate) payloadSend.expirationDate = (0, _utils.convertDateISO)(payloadSend.expirationDate);
            if (payloadSend.harvestDate) payloadSend.harvestDate = (0, _utils.convertDateISO)(payloadSend.harvestDate);
            delete payload.id;
            _context4.n = 2;
            return _services.traceabilityTagService.update(payloadSend, id);
          case 2:
            _yield$traceabilityTa3 = _context4.v;
            data = _yield$traceabilityTa3.data;
            successMessage = _router.default.app.$t('pages.traceability_tags.messages.update_success');
            _helpers.messageHelper.success(successMessage);
            _context4.n = 3;
            return commit(MutationTypes.REMOVE_TRACEABILITY_TAG_LIST_CREATED, id);
          case 3:
            commit(MutationTypes.ADD_TRACEABILITY_TAG_LIST_CREATED, data);
            return _context4.a(2, data);
          case 4:
            _context4.p = 4;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 4]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }()),
  addProductTraceabilityTags: function () {
    var _addProductTraceabilityTags = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref9, payload) {
      var commit, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref9.commit;
            _context5.p = 1;
            commit(MutationTypes.ADD_TRACEABILITY_TAG_LIST_CREATED, payload);
            return _context5.a(2, true);
          case 2:
            _context5.p = 2;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 2]]);
    }));
    function addProductTraceabilityTags(_x9, _x0) {
      return _addProductTraceabilityTags.apply(this, arguments);
    }
    return addProductTraceabilityTags;
  }(),
  removeProductTraceabilityTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref0, id) {
      var commit, successMessage, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref0.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _services.traceabilityTagService.deleteItem(id);
          case 2:
            successMessage = _router.default.app.$t('pages.traceability_tags.messages.delete_success');
            _helpers.messageHelper.success(successMessage);
            commit(MutationTypes.REMOVE_TRACEABILITY_TAG_LIST_CREATED, id);
            return _context6.a(2, true);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref1.apply(this, arguments);
    };
  }()),
  resetProductTraceabilityTags: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref10) {
      var commit, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref10.commit;
            _context7.p = 1;
            commit(MutationTypes.RESET_TRACEABILITY_TAG_LIST_CREATED);
            return _context7.a(2, true);
          case 2:
            _context7.p = 2;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 2]]);
    }));
    return function (_x11) {
      return _ref11.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};